import './styles.module.less';
import {lazyComponent} from '@esgi/core/react';

export const Agreements = lazyComponent(() => import('./login/agreements/page'));
export const DevLogin = lazyComponent(() => import('./login/dev-login/developer-login'));
export const ByClassLink = lazyComponent(() => import('./login/integrations/by-class-link'));
export const ByCrm = lazyComponent(() => import('./login/integrations/by-crm'));
export const ByLinkedClever = lazyComponent(() => import('./login/integrations/by-linked-clever'));
export const ByNotLinkedClever = lazyComponent(() => import('./login/integrations/by-not-linked-clever/page'));
export const ByRenew = lazyComponent(() => import('./login/integrations/by-renew'));